import PropTypes from 'prop-types';

export const loginTemplatePropTypes = {
  t: PropTypes.func.isRequired,
  formRef: PropTypes.func.isRequired,
  emailFieldRef: PropTypes.func.isRequired,
  passwordFieldRef: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  errorMessage: PropTypes.string
};
